var map = {
	"./2019-01-27-hello-world.md": 29,
	"./2019-06-15-javascript-string-methods-reimplementing-tolowercase-and-touppercase.md": 30,
	"./2019-07-07-javascript-string-methods-reimplementing-trim.md": 31,
	"./2019-12-16-lets-build-christmas-lights-with-html-css-javascript.md": 32,
	"./2020-03-08-javascript-array-methods-reimplementing-slice.md": 33
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;


//////////////////
// WEBPACK FOOTER
// ./src/posts nonrecursive \.md
// module id = 99
// module chunks = 0